import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import axios from 'axios';
import apiClient from "../../api/apiClient";

function Projects() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
      apiClient.get('api/projects/')
 
      .then((response) => setProjects(response.data))
      .catch((error) => console.error(error));
  }, []);


  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Work</strong>
        </h1>
        <p style={{ color: "white" }}>
          <h4>
          Here are a few projects I've worked on recently.
          </h4>
        </p>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projects.map((project) => (
            <Col xs={12} sm={12} md={6} lg={4} className="project-card" key={project.id}>
            <ProjectCard
                key={project.id}
                imgPath={project.image}
                isBlog={false}
                title={project.title}
                description={project.description}
                technologies={`Backend: ${project.tools.backend_framework}, Database: ${project.tools.database}, Deployment: ${project.tools.deployment}, Frontend: ${project.tools.frontend_framework}, Other Tools: ${project.tools.other_tools}`}
                ghLink={project.link}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
